import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { Bar } from "react-chartjs-2";
import { Card as MuiCard, CardContent, CardHeader } from "@mui/material";
import { spacing } from "@mui/system";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
);

const Card = styled(MuiCard)(spacing);

const ChartWrapper = styled.div`
  height: 240px;
  width: 100%;
`;

const BarChart = ({ theme, barChartData }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Richieste",
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        hoverBackgroundColor: theme.palette.primary.main,
        hoverBorderColor: theme.palette.primary.main,
        data: [],
        barPercentage: 0.5,
        categoryPercentage: 0.5,
      },
    ],
  });

  useEffect(() => {
    if (barChartData) {
      const labels = barChartData.map((item) => item.giorno);
      const dataValues = barChartData.map((item) => item.Tot);

      setData({
        labels,
        datasets: [
          {
            ...data.datasets[0],
            data: dataValues,
          },
        ],
      });
    }
  }, [barChartData, theme.palette.primary.main]);

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: theme.palette.mode === "dark" ? "white" : "black",
        anchor: "end",
        align: "top",
        offset: -5,
        formatter: (value) => value,
      },
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
        ticks: {
          color: theme.palette.mode === "dark" ? "white" : "black",
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: theme.palette.mode === "dark" ? "white" : "black",
        },
      },
    },
  };

  return (
    <Card mb={4} sx={{ height: "100%" }}>
      <CardHeader title="Trend Settimanale" />
      <CardContent>
        <ChartWrapper>
          <Bar data={data} options={options} />
        </ChartWrapper>
      </CardContent>
    </Card>
  );
};

export default withTheme(BarChart);
